const SUSPEND_POSTING = 'avisos/suspend/SUSPEND_POSTING';
const SUSPEND_POSTING_COMPLETED = 'avisos/suspend/SUSPEND_POSTING_COMPLETED';
const SUSPEND_POSTING_FAILED = 'avisos/suspend/SUSPEND_POSTING_FAILED';
const RESET_SUSPEND_POSTING = 'avisos/suspend/RESET_SUSPEND_POSTING';

export { SUSPEND_POSTING, SUSPEND_POSTING_COMPLETED, SUSPEND_POSTING_FAILED, RESET_SUSPEND_POSTING };
